import { PowerIcon } from "@heroicons/react/24/outline";
import { Link, useNavigate } from "react-router-dom";
import AppLogo from "./app-logo";
import NavLinks from "./nav-links";
import { useAuth } from "../../context/AuthContext";
import AuthService from "../../services/AuthService";
import { UserRole } from "../../enums";

export default function SideNav() {
  const { logout,user } = useAuth();
  const navigate = useNavigate();
  const authService = new AuthService();
  const handleSignOut = async () => {
    try {
    await authService.logout();
      logout();
      navigate("/");
      // Optionally, redirect to login page or show a success message
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <div className="flex h-full flex-col px-3 py-4 md:px-2">
      <Link
        className="mb-2 flex h-22   rounded-md    md:h-42"
        to={user?.role === UserRole.USER?"/client":"/admin"}
      >
        {user?.profileImage?<img src={user?.profileImage} width={240}
            height={160} className="hidden rounded-md md:block"></img>:<AppLogo />}        
        {/* <div className="w-32 text-white md:w-56">
        </div> */}
      </Link>
      <div className="flex grow flex-row justify-between space-x-2 md:flex-col md:space-x-0 md:space-y-2">
        <NavLinks role={user?.role} />
        <div className="hidden h-auto w-full grow rounded-md bg-gray-50 md:block"></div>
        <form action={handleSignOut}>
          <button className="flex h-[48px] w-full grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-purple-100 hover:text-purple-600 md:flex-none md:justify-start md:p-2 md:px-3">
            <PowerIcon className="w-6" />
            <div className="hidden md:block">Sign Out</div>
          </button>
        </form>
      </div>
    </div>
  );
}
